import { Box, HStack, VStack } from "@chakra-ui/react";
import {
  AddCircle as AddCircleIcon,
  DeleteOutline as DeleteOutlineIcon,
} from "@mui/icons-material";
import { FieldArray, useField } from "formik";
import { FC, useCallback } from "react";

import { SymbolOutlineButton } from "~/src/components/common/Button";
import { FormControl } from "~/src/components/common/forms/FormControl";
import { FormikSelectField } from "~/src/components/common/forms/FormikSelectField";
import { FormikTextField } from "~/src/components/common/forms/FormikTextField";
import { IconButton } from "~/src/components/common/IconButton";
import { Switch } from "~/src/components/common/Switch";
import { useOpenState } from "~/src/lib/hooks";

export type Props = {
  name: string;
  label: string;
};

export const TargetCookieListField: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ name, label }) => {
  const [targetCookies, , { setValue }] =
    useField<{ key: string; value: string; matchType: boolean }[]>(name);

  const { isOpen, onOpen, onClose } = useOpenState(
    targetCookies.value ? targetCookies.value.length > 0 : false
  );

  const handleChange = useCallback(() => {
    if (isOpen) {
      onClose();
      setValue([]);
    } else {
      onOpen();
    }
  }, [isOpen, onClose, onOpen, setValue]);

  const hideLabel = label === "";

  return (
    <FieldArray
      name={name}
      // eslint-disable-next-line react/jsx-no-bind
      render={(arrayHelpers) => (
        <FormControl label={label} hideLabel={hideLabel}>
          <Box width="100%" display="block">
            <Switch isChecked={isOpen} onChange={handleChange} />
          </Box>
          <VStack width="100%">
            {isOpen && (
              <>
                {targetCookies.value &&
                  targetCookies.value.length > 0 &&
                  targetCookies.value.map((id, index) => (
                    <HStack key={index} width="100%" alignItems="flex-start">
                      <VStack width="100%" flex={1}>
                        <Box width="100%">
                          <FormikTextField
                            type="text"
                            mode="fill"
                            name={`${name}.${index}.key`}
                            placeholder="keyを入力"
                          />
                        </Box>
                        <Box width="100%">
                          <FormikTextField
                            type="text"
                            mode="fill"
                            name={`${name}.${index}.value`}
                            placeholder="valueを入力"
                          />
                        </Box>
                      </VStack>

                      <Box width={120}>
                        <FormikSelectField
                          name={`${name}.${index}.matchType`}
                          options={[
                            { label: "等しい", value: true },
                            { label: "等しくない", value: false },
                          ]}
                        />
                      </Box>
                      <Box>
                        <IconButton
                          size="24px"
                          // eslint-disable-next-line react/jsx-no-bind
                          onClick={() => arrayHelpers.remove(index)}
                          icon={<DeleteOutlineIcon />}
                        />
                      </Box>
                    </HStack>
                  ))}
                <Box width="100%">
                  <SymbolOutlineButton
                    icon={<AddCircleIcon />}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() => arrayHelpers.push({})}
                  >
                    条件を追加
                  </SymbolOutlineButton>
                </Box>
              </>
            )}
          </VStack>
        </FormControl>
      )}
    />
  );
};
